export type IBlockUI = (
  message?: string | IjQueryElmOrHtmlElm,
  target?: IjQueryElmOrHtmlElm,
  unblock?: boolean,
  iconOnly?: boolean,
  animate?: boolean,
  boxed?: boolean
) => void;

export function blockUI(
  message?: string | IjQueryElmOrHtmlElm,
  target?: IjQueryElmOrHtmlElm,
  unblock = false,
  iconOnly = false,
  animate = false,
  boxed = true
) {
  // Allow to only pass element and keep backwards compatability
  let $target;
  let _message;
  if (arguments.length === 1) {
    $target = $(message as string);
    _message =
      window.DexeroCoreApp.options && window.DexeroCoreApp.options.langObj
        ? window.DexeroCoreApp.options.langObj.waitMsgText
        : '';
  } else {
    $target = target !== null && target !== undefined ? target : $('#content');
    _message =
      message !== null && message !== undefined
        ? message
        : window.DexeroCoreApp.options && window.DexeroCoreApp.options.langObj
        ? window.DexeroCoreApp.options.langObj.waitMsgText
        : '';
  }

  if (unblock) {
    window.DexeroCoreApp.doUnblockUI($target);
  } else if (iconOnly) {
    window.DexeroCoreApp.doBlockUI({
      animate,
      iconOnly,
      target: $target,
    });
  } else {
    window.DexeroCoreApp.doBlockUI({
      animate,
      boxed,
      message: _message as string,
      target: $target,
    });
  }
}
